<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Issue Tracker Report</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <img id="logoId" src="../../../public/images/logo.png" style="width:40px; height:40px; display:none;">
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header p-0">
                                <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeTab === 'completed' }" @click.prevent="switchTab('completed')">Completed</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeTab === 'pending' }" @click.prevent="switchTab('pending')">Pending</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="start_date">Start Date</label>
                                            <input type="date" id="start_date" v-model="search.start_date" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="end_date">End Date</label>
                                            <input type="date" id="end_date" v-model="search.end_date" class="form-control">
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                        <div class="form-group d-flex align-items-center gap-2" style="margin-top:28px;">
                                            <button class="btn btn-info btn-sm mr-1" type="submit" @click.prevent="searchData">
                                                <i class="fa fa-search"></i> Filter
                                            </button>

                                           <button class="btn btn-warning btn-sm" type="button" @click.prevent="excelDownload">
                                                <i class="fa fa-download"></i> Excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <b-overlay :show="loading">
                                    <div class="table-responsive">
                                        <div style="width:100%; overflow-x:auto;">
                                            <table class="table table-bordered table-striped table-sm" id="orderTable">
                                                <thead>
                                                    <tr class="text-center">
                                                        <th>SL</th>
                                                        <th>Issue Track By</th>
                                                        <th>{{ activeTab === 'pending' ? 'Total Pending' : 'Total Completed' }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,key) in listData" :key="key" class="text-center">
                                                        <td>{{ key+1 }}</td>
                                                        <td>{{ item.assigned_user ? item.assigned_user.name : '' }}</td>
                                                        <td>{{ item.total }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>  
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
    </div>
</template>
<script>
    import config from '@/config' 
    import moment from 'moment'    
    
    export default {
        name:'IssueTrackerReport',
        data () {
            return {
                loading: false,
                activeTab: 'completed',
                search: {
                    start_date: moment().subtract(7,'d').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD')
                },
                page: 1,
                key:'',
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        created () {
            this.loadData() 
        },
        computed : {
            authUser () {
                return this.$store.state.authUser
            },
            stateReload () {
                return this.$store.state.stateReload
            },
            commonObj () {
                return this.$store.state.commonObj
            },
            customState () {
                return this.$store.state
            },
            listData () {
                return this.$store.state.list
            },
        },
        methods:{
            switchTab (tab) {
                if (this.activeTab === tab) {
                    return
                }
                this.activeTab = tab
                this.pagination.currentPage = 1
                this.loadData()
            },
            searchData () {
                this.page = 1
                this.totalOrder = 0
                this.loadData()
            },
            async loadData(){
                this.loading = true
                const params = Object.assign({}, this.search, { tab: this.activeTab, page: this.pagination.currentPage, per_page: this.pagination.perPage })
                const response = await config.getData('/report/issue-tracker-report', params)
                this.loading = false
                if (response.success) {
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                    this.totalOrder = response.data.total
                } else {
                    this.$store.dispatch('setList', [])
                }
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
            },
            async excelDownload () {
                this.loader = true
                try {
                    const response = await config.getFile('excel-download/issue-tracker', Object.assign({}, this.search, { tab: this.activeTab }))
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Issue-tracker.csv')
                    document.body.appendChild(link)
                    link.click()
                    link.remove()
                    window.URL.revokeObjectURL(url)
                } catch (error) {
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })
                }
                this.loader = false
            }
        },
    }
</script>
